/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React, { Component } from 'react';
import { Segment, Grid /*, Icon*/, List } from 'semantic-ui-react';

import tutorials from '../pages/helpCenter/sections/tutorials/tutorials.json';
import find from 'lodash/find';
import isNumber from 'lodash/isNumber';
import { inject, observer } from 'mobx-react';

import _ from '../translations';
import get from 'lodash/get';
import map from 'lodash/map';

const styles = ({ visible }) => ({
    container: {
        boxShadow: 'none',
        margin: '1rem',
        display: visible ? 'block' : 'none',
        border: 'none',
    },
    hideText: {
        cursor: 'pointer',
    },
    hideIcon: {
        cursor: 'pointer',
        marginLeft: '10px',
        color: 'rgb(149, 140, 139)',
    },
});

/**
 * A container for form segments, allows to toggle the content visibility
 */
@inject('tutorialsStore')
@observer
class TutorialSegment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            popupVisible: false,
        };
    }

    hide = () => {
        const { tutorialId = 1, onHide, tutorialsStore } = this.props;

        if (isNumber(tutorialId)) {
            tutorialsStore.setAsHidden(tutorialId);
        }
        this.setState({ visible: false }, onHide);
    };

    render() {
        const { tutorialId = 1 } = this.props;
        const style = styles(this.state);
        const tutorial = find(tutorials.items, { _id: tutorialId });

        return (
            <React.Fragment>
               <Segment style={style.container}>
                        <Grid columns={16}>
                            <Grid.Column width={16} style={{ display: 'flex', flexDirection: 'column' }}>
                                <h3
                                    style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        fontStyle: 'normal',
                                        fontStretch: 'normal',
                                        lineHeight: 'normal',
                                        letterSpacing: 'normal',
                                        color: '#0c3454',
                                        marginTop: '10px',
                                        cursor:'pointer'
                                    }}
                                    onClick={() => window.open(get(tutorial,'link'),'_blank')}
                                >
                                    {_(tutorial.title)}
                                </h3>
                                <p
                                    style={{
                                        fontSize: '14px',
                                        fontWeight: 'normal',
                                        fontStyle: 'normal',
                                        fontStretch: 'normal',
                                        lineHeight: 'normal',
                                        letterSpacing: 'normal',
                                        color: '#0c3454',
                                    }}
                                >
                                    {_(tutorial.description)}
                                </p>
                                <List horizontal>
                                  {map(get(tutorial,'links', []), (link, key) => {
                                      return(
                                        <List.Item style={{ margin: '0px', marginRight:'15px'  }} key={key}><a href={get(link,'link','')} rel="noopener noreferrer" target="_blank">{_(get(link,'name',''))}</a></List.Item>
                                      )
                                  })}
                                </List>
                            </Grid.Column>
                        </Grid>
                    </Segment>
            </React.Fragment>
        );
    }
}

export default TutorialSegment;
